import React from "react"
import { Icon, IconProps } from "@blueprintjs/core"
import classNames from "utils/classNames"

interface InteractiveIconProps extends IconProps {
  onClick?: any
}
const InteractiveIcon = ({ className, ...props }: InteractiveIconProps) => {
  return (
    <Icon className={classNames("vt-interactive-icon", className)} {...props} />
  )
}

export default InteractiveIcon
